import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/confirmation/$token')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/auth/new-password/$token',
      params: { token: params.token },
    })
  },
  component: RouteComponent,
})

function RouteComponent() {
  return null
}
